/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { CommunityModule } from '../common/community/community.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { UtEditorModule } from '../common/ut-editor/ut-editor.module';
import { CommentThreadComponent } from './comment-thread.component';

// Not standalone, for the same reason as CommunityFeedModule: the like, hide and report actions pull in
// UpgradeModule.
@NgModule({
  imports: [CommonModule, UIRouterModule, SharedModule, CommonComponentsModule, CommunityModule, CommunityFeedModule, UtEditorModule],
  declarations: [CommentThreadComponent],
  exports: [CommentThreadComponent],
})
class CommentThreadModule {}

export { CommentThreadModule };
